export default __webpack_public_path__ + "static/media/xp-black.af040f4a.svg";